'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
* This component adds an icon and the pop over for an onClick
* */

// helper function to get an element's exact position
function getPosition(el) {
	var xPosition = 0;
	var yPosition = 0;

	while (el) {
		if (el.tagName === 'body') {
			// deal with browser quirks with body/window/document and page scroll
			var xScrollPos = el.scrollLeft || document.documentElement.scrollLeft;
			var yScrollPos = el.scrollTop || document.documentElement.scrollTop;

			xPosition += el.offsetLeft - xScrollPos + el.clientLeft;
			yPosition += el.offsetTop - yScrollPos + el.clientTop;
		} else {
			xPosition += el.offsetLeft - el.scrollLeft + el.clientLeft;
			yPosition += el.offsetTop - el.scrollTop + el.clientTop;
		}

		el = el.offsetParent;
	}
	return {
		x: xPosition,
		y: yPosition
	};
}

var IconOverlay = function (_React$Component) {
	_inherits(IconOverlay, _React$Component);

	function IconOverlay(props, context) {
		_classCallCheck(this, IconOverlay);

		var _this = _possibleConstructorReturn(this, (IconOverlay.__proto__ || Object.getPrototypeOf(IconOverlay)).call(this, props, context));

		_this.onClick = _this.onClick.bind(_this);
		_this.state = {
			x: -1,
			y: -1,
			show: false
		};
		return _this;
	}

	_createClass(IconOverlay, [{
		key: 'onClick',
		value: function onClick(ev) {
			ev.preventDefault();
			var target = ev.target;

			var _getPosition = getPosition(target),
			    x = _getPosition.x,
			    y = _getPosition.y;

			this.setState(function (state) {
				return {
					x: x + target.clientWidth, // add the width of the target
					y: y - 75 + target.clientHeight / 2, // height of popover is 150px
					show: !state.show
				};
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var className = 'icon-overlay-info gg icon-GG-' + this.props.icon + ' text';
			var MyPopover = this.props.infoPopover;
			return _react2.default.createElement(
				'span',
				{ id: 'iconPopOver' },
				_react2.default.createElement(_reactBootstrap.Button, { className: className, onClick: this.onClick, alt: this.props.altText }),
				this.props.infoPopover && _react2.default.createElement(
					_reactBootstrap.Overlay,
					{
						container: this,
						target: this.state.target,
						show: this.state.show,
						onHide: function onHide() {
							return _this2.setState(function () {
								return { show: false };
							});
						},
						placement: 'right',
						trigger: 'click',
						rootClose: true,
						containerPadding: 0
					},
					_react2.default.createElement(MyPopover, { positionTop: this.state.y, positionLeft: this.state.x })
				)
			);
		}
	}]);

	return IconOverlay;
}(_react2.default.Component);

IconOverlay.defaultProps = {
	icon: 'info', // Always show a information icon for default when no icon is passed in props
	altText: 'additional info'
};
IconOverlay.propTypes = {
	icon: _propTypes2.default.string,
	altText: _propTypes2.default.string,
	infoPopover: _propTypes2.default.func
};

var _default = IconOverlay;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(getPosition, 'getPosition', 'src/components/IconOverlay.jsx');

	__REACT_HOT_LOADER__.register(IconOverlay, 'IconOverlay', 'src/components/IconOverlay.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/IconOverlay.jsx');
}();

;